import { Alerts } from "./Alerts";
import { CouponForm } from "./CouponForm";
import { Item } from "./Item";
import { PricePreview } from "./PricePreview";
import { Root } from "./Root";

export const CheckoutForm = Object.assign(Root, {
  Item,
  PricePreview,
  CouponForm,
  Alerts,
});
